export default {
    state: {
        isLoading: false
    },
    getters: {
        isLoading: state => state.isLoading
    },
    mutations: {
        setTrue (state) {
            state.isLoading = true;
        },
        setFalse (state) {
            state.isLoading = false;
        }
    },
    actions: {
        endRequest (context) {
            context.commit('setFalse')
        },
        startRequest (context) {
            context.commit('setTrue')
        }
    }
}